import {
  DynamicScriptOptions,
  useDynamicScript,
  ValueType
} from '~/App/shared/hooks/useDynamicScript';
import { googleRecaptchaSource } from '~/config/dynamicScriptsTags';

export const useRecaptcha = <
  T extends Record<string, ValueType> = Record<string, never>
>(
  options?: DynamicScriptOptions<T>
) => useDynamicScript(googleRecaptchaSource, options);
